<template>
  <div
    class="w-full md:px-5"
    :class="{ 'navbar-banner-spacer': showBlackFridaybanner }"
  >
    <div
      v-if="isWebshop"
      class="webshop-bar bg-gray-100 text-gray-600"
    >
      <div
        class="flex justify-end container xs-px-0"
      >
        <div
          v-if="userAuthenticated && !hideWallet"
          class="flex items-center px-4 border-l border-gray-200 ota-p14"
          v-html="$t('Loyalty.Webshop.Navbar.YourCredits', { price: `
          <span class='text-orange-300 montserrat-currency font-bold pl-2'>
            ${getEuros(walletAmount)}
          </span>` })"
        />
        <div class="flex items-center px-4 border-l border-gray-200 ota-p14 cursor-pointer">
          <a :href="faqLink">
            {{ $t('Loyalty.Webshop.Navbar.FAQ') }}
          </a>
        </div>
        <div
          v-click-outside="deactivateI18nDropdown"
          class="language-switcher relative border-l border-gray-200 z-40 md:border-r md:mr-12 lg:mr-20"
        >
          <span class="flex items-center cursor-pointer px-4 py-3" @click="i18nDropdown.active = !i18nDropdown.active">
            <OSvg v-if="countryDropdownSettings.currentCountry.svg" class="w-7 h-auto rounded" :svg="countryDropdownSettings.currentCountry.svg" />
          </span>
          <NavbarDropdown
            :title="$t('Navbar.SelectYourLanguage')"
            :active="i18nDropdown.active"
            size="lg"
          >
            <form class="px-7 py-4" @submit="onSubmitI18n">
              <OSelect
                class="mb-4"
                :label="$t('Navbar.Language')"
                :value="language"
                :options="languageDropdownSettings.items"
                svg-classes="rounded"
                :clearable="false"
                @input="setLanguage"
              />
              <OSelect
                :label="$t('Navbar.Country')"
                :value="country"
                :options="countryOptions"
                :disabled="userAuthenticated"
                svg-classes="rounded"
                :clearable="false"
                @input="setCountry"
              />
              <div class="flex justify-end w-full ">
                <OButton
                  type="submit"
                  class="mt-4"
                  v-bind="i18nSaveButtonProps"
                  :disabled="!language.svg || !country.svg"
                >
                  {{ $t('FormNavigation.Save') }}
                </OButton>
              </div>
            </form>
          </NavbarDropdown>
        </div>
      </div>
    </div>
    <div
      class="h-16 py-4 md:py-12 bg-white md:shadow-none w-full top-0 z-70 flex items-center justify-center"
      :class="{
        'fixed': !minimal,
        'md:relative': !isWebshop,
        'shadow-md': !hideShadow
      }"
    >
      <div
        class="container w-full"
        :class="{
          'xs-px-5': isWebshop
        }"
      >
        <div class="row flex items-center">
          <div class="col-xs-offset-0 col-md-3 cursor-pointer" :class="logoWrapperClasses" @click="toggleHamburgerMenu(false, logoLink)">
            <OSvg svg="logo" class="w-48 max-w-full text-black fill-current" :class="{ 'mx-auto': minimal }" />
          </div>
          <div
            v-if="isWebshop"
            class="col-xs-5 col-md-7 flex justify-end"
          >
            <div class="flex">
              <NuxtLink :to="!userAuthenticated ? '/login' : '/account/loyalty-program'">
                <div class="px-2 cursor-pointer md:px-4">
                  <OSvg svg="person" />
                </div>
              </NuxtLink>
              <div v-if="showWishlist" class="px-2 cursor-pointer relative md:px-4">
                <OSvg svg="heart-outlined" />
                <div class="svg-alert">
                  1
                </div>
              </div>
              <div v-if="!hideCart" class="pl-2 cursor-pointer relative md:px-4" @click="$emit('openCart')">
                <OSvg svg="cart" class="fill-gray-400" width="24" height="23" />
                <div v-if="cart.length" class="svg-alert">
                  {{ totalCartItems }}
                </div>
              </div>
            </div>
          </div>
          <nav v-if="!minimal" class="col-xs-7 col-md-6 col-lg-5 desktop-menu justify-center items-center hidden md:flex">
            <!-- TODO: when website is also running on NUXT change these links to nuxt-link components. -->
            <div
              v-for="menuItem in menuItems"
              :key="menuItem.link"
            >
              <template v-if="!menuItem.hideInNavbar">
                <NuxtLink
                  v-if="menuItem.nuxtLink"
                  v-t="menuItem.text"
                  :to="{ path: $i18n.localePath({ name: menuItem.nuxtLink, params: { ...(menuItem.params ? menuItem.params : {}) } }), hash: menuItem.hash }"
                  class="py-2 md:py-3 mx-3 xl:mx-8 relative flex-initial whitespace-no-wrap ota-small-light"
                  @click.native="onMenuClick(menuItem)"
                />
                <a
                  v-else
                  :href="menuItem.link"
                  class="py-2 md:py-3 mx-3 xl:mx-8 relative flex-initial whitespace-no-wrap ota-small-light"
                >
                  {{ menuItem.text }}
                </a>
              </template>
            </div>
          </nav>
          <div class="col-xs-3 col-lg-2 hidden md:flex items-center justify-end" :class="{ 'ml-auto': minimal }">
            <div
              v-if="!minimal"
              v-click-outside="deactivateI18nDropdown"
              class="language-switcher relative"
            >
              <span class="flex items-center cursor-pointer" @click="i18nDropdown.active = !i18nDropdown.active">
                <OSvg v-if="countryDropdownSettings.currentCountry.svg" class="w-7 h-auto rounded" :svg="countryDropdownSettings.currentCountry.svg" />
              </span>
              <NavbarDropdown
                :title="$t('Navbar.SelectYourLanguage')"
                :active="i18nDropdown.active"
                size="lg"
              >
                <form class="px-7 py-4" @submit="onSubmitI18n">
                  <OSelect
                    class="mb-4"
                    :label="$t('Navbar.Language')"
                    :value="language"
                    :options="languageDropdownSettings.items"
                    svg-classes="rounded"
                    :clearable="false"
                    @input="setLanguage"
                  />
                  <OSelect
                    :label="$t('Navbar.Country')"
                    :value="country"
                    :options="countryOptions"
                    :disabled="userAuthenticated"
                    svg-classes="rounded"
                    :clearable="false"
                    @input="setCountry"
                  />
                  <div class="flex justify-end w-full ">
                    <OButton
                      type="submit"
                      class="mt-4"
                      v-bind="i18nSaveButtonProps"
                      :disabled="!language.svg || !country.svg"
                    >
                      {{ $t('FormNavigation.Save') }}
                    </OButton>
                  </div>
                </form>
              </NavbarDropdown>
            </div>
            <div
              v-if="userAuthenticated && !isWebshop"
              v-click-outside="deactivateAccountDropdown"
              class="hidden md:block border-l border-gray-200 ml-2 pl-2 xl:ml-3 xl:pl-3 relative"
            >
              <div
                class="flex items-center justify-end cursor-pointer relative"
                @click="toggleAccountDropdown"
              >
                <span class="ota-small truncate w-12" v-text="user.firstName" />
                <OImage
                  :mobile="userAvatar.mobile"
                  :desktop="userAvatar.desktop"
                  :alt="$t('Accessibilty.AltTags.PictureOfAvatar')"
                  class="avatar ml-3"
                />
                <client-only>
                  <span v-if="openPayments.length > 0" class="bg-red-300 w-3 h-3 rounded-full absolute bottom-0 right-0 shadow" />
                </client-only>
              </div>
              <NavbarDropdown
                class="relative"
                :button-link="accountDropdown.buttonLink"
                :button-text="accountDropdown.buttonText"
                :active="accountDropdown.active"
                :items="accountDropdown.items"
                @deactivate="deactivateAccountDropdown"
              >
                <template v-slot:footer>
                  <div v-if="openPayments.length > 0" class="payment-dot absolute w-2 h-2 rounded-full bg-red-300" />
                  <div class="px-5">
                    <hr class="mt-10 border-gray-200">
                    <div class="flex items-center cursor-pointer py-4">
                      <OSvg svg="logout" class="w-5 h-auto mr-3" />
                      <span v-t="'Navbar.Logout'" class="ota-body-light" @click="logout" />
                    </div>
                  </div>
                </template>
              </NavbarDropdown>
            </div>
            <OButton
              v-if="!userAuthenticated && !minimal && !showSignupButton"
              size="sm"
              button-type="border"
              variant="primary"
              class="ml-4"
              @click.native="toggleHamburgerMenu(false, loginLink)"
            >
              <span class="truncate" v-text="$t('LoginForm.Login')" />
            </OButton>
            <OButton
              v-else-if="showSignupButton"
              size="sm"
              variant="secondary"
              class="ml-4 px-3 whitespace-no-wrap"
              @click.native="$router.push(signupLink)"
            >
              {{ $t('TryItNow.StartNow') }}
            </OButton>
          </div>
          <div v-if="!minimal && !showSignupButton" class="md:hidden col-xs-3 flex justify-end h-10" @click="toggleHamburgerMenu()">
            <OSvg v-if="!hamburgerMenu.display" svg="menu-closed" class="w-6" />
            <OSvg v-else svg="menu-open" class="w-6" />
          </div>
          <div
            v-else-if="showSignupButton"
            class="md:hidden flex justify-end col-xs-5"
          >
            <OButton
              v-if="showSignupButton"
              size="sm"
              variant="secondary"
              class="px-3 whitespace-no-wrap"
              @click.native="$router.push(signupLink)"
            >
              {{ $t('TryItNow.StartNow') }}
            </OButton>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-border hidden md:block md:container md:border-b md:border-gray-50" />
    <BlackFridayBanner
      v-if="showBlackFridaybanner"
      @click="$router.push($i18n.localePath({ name: 'signup' }))"
    />
    <div
      class="mobile-hamburger-bg fixed top-0 right-0 bottom-0 left-0 md:hidden bg-black bg-opacity-50 z-60"
      :class="mobileHamburgerBgClasses"
      @click="toggleHamburgerMenu(false)"
    />
    <div
      class="mobile-hamburger fixed flex md:hidden bg-white z-60 top-0 bottom-0 pt-16 transition-all duration-300"
      :class="mobileHamburgerClasses"
    >
      <div class="w-full px-10 py-7 flex items-center" :class="userAuthenticated ? 'justify-between' : 'justify-center' ">
        <div v-if="userAuthenticated" class="flex items-center justify-start">
          <OImage
            :mobile="userAvatar.mobile"
            :desktop="userAvatar.desktop"
            :alt="$t('Accessibilty.AltTags.PictureOfAvatar')"
            class="avatar mr-4"
          />
          <span class="ota-subtitle-heavy" v-text="user.firstName" />
        </div>
        <OButton
          v-else
          class="w-full"
          variant="secondary"
          @click.native="toggleHamburgerMenu(false, loginLink)"
        >
          {{ $t('LoginForm.Login') }}
        </OButton>
      </div>
      <client-only>
        <ONotification
          v-if="openPayments.length"
          type="danger"
          :button-text="$t('Home.OpenPayment.PayNow')"
          :title="$t('Home.OpenPayment.Title')"
          text=""
          :corners-rounded="false"
          @click="toggleHamburgerMenu(false, 'account-orders')"
        />
      </client-only>
      <div
        v-if="userAuthenticated"
        class="px-10 py-8 bg-white"
      >
        <OButton
          class="w-full"
          @click.native="toggleHamburgerMenu(false, accountLink)"
        >
          {{ $t('Navigation.Account') }}
        </OButton>
      </div>
      <nav class="mobile-menu bg-white" :class="mobileMenuClasses">
        <!-- TODO: when website is also running on NUXT change these links to nuxt-link components. -->
        <div
          v-for="menuItem in menuItems"
          :key="menuItem.link"
        >
          <NuxtLink
            v-if="menuItem.nuxtLink"
            v-t="menuItem.text"
            :to="{ path: $i18n.localePath({ name: menuItem.nuxtLink, params: { ...(menuItem.params ? menuItem.params : {}) } }), hash: menuItem.hash }"
            class="px-10 py-4 relative block text-black whitespace-no-wrap ota-body-light"
            @click.native="onMenuClick(menuItem)"
          />
          <a
            v-else
            :href="menuItem.link"
            class="px-10 py-4 relative block text-black whitespace-no-wrap ota-body-light"
            @click="toggleHamburgerMenu(false)"
          >
            {{ menuItem.text }}
          </a>
        </div>
      </nav>
      <div v-if="userAuthenticated" class="w-full">
        <div
          class="mobile-language-selection-button flex items-center cursor-pointer px-10 bg-white py-5 border-b border-gray-100"
          @click="logout"
        >
          <OSvg class="mr-3" svg="logout" />
          <span v-t="'Navbar.Logout'" class="ota-body-light" />
        </div>
      </div>
      <div class="mobile-language-selection w-full">
        <div
          class="mobile-language-selection-button flex items-center justify-between cursor-pointer px-10 bg-white py-6"
          @click="hamburgerMenu.languageSelection.active = !hamburgerMenu.languageSelection.active"
        >
          <div class="flex items-center">
            <OSvg class="mr-3 h-4 w-auto rounded" :svg="country.svg" />
            <span class="ota-small-light" v-text="'Country and language'" />
          </div>
          <OSvg
            svg="arrow-down"
            class="float-right mt-1 ml-3 w-4 h-4 fill-current text-primary transition-transform duration-300"
            :class="{ 'transform -rotate-180': hamburgerMenu.languageSelection.active }"
          />
        </div>
        <div :class="mobileLanguageSelectionClasses" class="mobile-language-selection-list flex justify-center">
          <form class="w-full px-10 py-4" @submit="onSubmitI18n">
            <OSelect
              class="mb-4"
              label="Language"
              :value="language"
              :options="languageDropdownSettings.items"
              svg-classes="rounded"
              :clearable="false"
              @input="setLanguage"
            />
            <OSelect
              class="select-country"
              label="Country"
              :value="country"
              :options="countryOptions"
              :disabled="userAuthenticated"
              svg-classes="rounded"
              :clearable="false"
              @input="setCountry"
            />
            <div class="flex justify-end w-full">
              <OButton
                variant="success"
                type="submit"
                class="mt-4"
                v-bind="i18nSaveButtonProps"
              >
                {{ $t('FormNavigation.Save') }}
              </OButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { SET_SIGNUP_STATE } from '@/utils/store/mutationTypes'
import { defaultState } from '@/enums/signup'
import { ButtonSizes, ButtonVariants } from '@/enums/components'
import { OPEN_PAYMENTS } from '@/utils/store/getterTypes'
import { vueWindowSizeMixin } from 'vue-window-size'
import { convertSrcSet, togglePageScroll, getEuros } from '@/utils/general'
import { ROUTER_HASH_UPDATED } from '@/events/eventTypes'
import ONotification from '@/components/ONotification/ONotification'
import { WomenCountries } from '@/enums/general'

const OButton = () => import('@/components/OButton')
const NavbarDropdown = () => import('@/components/NavbarDropdown/NavbarDropdown')
const OSvg = () => import('@/components/OSvg')
const OSelect = () => import('@/components/OSelect/OSelect')
const OImage = () => import('@/components/OImage/OImage')
const BlackFridayBanner = () => import('@/components/BlackFriday/BlackFridayBanner')

export default {
  name: 'Navbar',
  components: {
    OImage,
    ONotification,
    OSelect,
    OSvg,
    BlackFridayBanner,
    OButton,
    NavbarDropdown
  },
  mixins: [vueWindowSizeMixin],
  props: {
    minimal: {
      type: Boolean,
      default: false
    },
    hideCart: {
      type: Boolean,
      default: false
    },
    hideShadow: {
      type: Boolean,
      default: false
    },
    cart: {
      type: Array,
      default: () => ([])
    },
    isWebshop: {
      type: Boolean,
      default: false
    },
    walletAmount: {
      type: Number,
      default: 0
    },
    showSignupButton: {
      type: Boolean,
      default: false
    },
    hideWallet: {
      type: Boolean,
      default: false
    },
    logoLink: {
      type: String,
      required: true
    },
    loginLink: {
      type: String,
      required: true
    },
    accountLink: {
      type: String,
      required: true
    },
    menuItems: {
      type: Array,
      required: true
    },
    languageDropdownSettings: {
      type: Object,
      required: true
    },
    accountDropdownSettings: {
      type: Object,
      required: true
    },
    countryDropdownSettings: {
      type: Object,
      required: true
    },
    user: {
      type: [Object, Boolean],
      default: null
    },
    userAuthenticated: {
      type: Boolean,
      default: false
    },
    showWishlist: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const currentCountry = { ...this.countryDropdownSettings.currentCountry }

    return {
      currentCountry,
      language: this.languageDropdownSettings.currentLanguage,
      i18nDropdown: {
        active: false,
        items: this.languageDropdownSettings.items
      },
      accountDropdown: {
        buttonLink: this.$i18n.localePath({ name: 'account' }),
        buttonText: 'Navbar.MyAccount',
        active: false,
        title: this.accountDropdownSettings.title,
        items: this.accountDropdownSettings.items
      },
      hamburgerMenu: {
        display: false,
        languageSelection: {
          active: false
        }
      }
    }
  },
  computed: {
    signupLink () {
      return this.$i18n.localePath({ name: 'signup' })
    },
    ...mapGetters('payment', {
      openPayments: OPEN_PAYMENTS
    }),
    totalCartItems () {
      return this.cart.reduce((acc, cartItem) => acc + cartItem.quantity, 0)
    },
    logoWrapperClasses () {
      return {
        'col-lg-offset-1': !this.minimal,
        'col-xs-9': !this.minimal && !this.showSignupButton,
        'col-xs-7': this.showSignupButton,
        'col-xs-12 col-md-12 w-full': this.minimal && !this.isWebshop,
        'col-md-offset-1 col-xs-7 ': this.isWebshop
      }
    },
    country: {
      get () {
        const country = { ...this.currentCountry }
        country.label = this.$t(country.label)

        return country
      },
      set (newValue) {
        this.currentCountry = newValue
      }
    },
    faqLink () {
      return `${process.env.BASE_URL}${this.$t('Loyalty.Webshop.Navbar.FAQLink')}`
    },
    showBlackFridaybanner () {
      const disabledRoutes = ['signup', 'account']
      const isDisabledRoute = disabledRoutes.some(path => this.$router.currentRoute.name && this.$router.currentRoute.name.includes(`lang-${path}`))

      const showfromDate = this.$moment('2021-11-25')
      const showtoDate = this.$moment('2021-11-30')
      const isDateToShowBanner = this.$moment().isBetween(showfromDate, showtoDate)

      return !isDisabledRoute && isDateToShowBanner
    },
    countryOptions () {
      const isWomenSegment = this.$route.name?.startsWith('lang-women')

      return this.countryDropdownSettings.items.map((item) => {
        return { ...item, label: this.$t(item.label) }
      }).filter((item) => {
        if (!isWomenSegment) {
          return true
        }

        return WomenCountries.includes(item.value)
      })
    },
    mobileHamburgerClasses () {
      return {
        'delay-300': this.hamburgerMenu.display,
        'delay-150': !this.hamburgerMenu.display,
        active: this.hamburgerMenu.display
      }
    },
    mobileHamburgerBgClasses () {
      return {
        active: this.hamburgerMenu.display,
        inactive: !this.hamburgerMenu.display
      }
    },
    mobileMenuClasses () {
      const classes = []
      if (this.hamburgerMenu.languageSelection.active) { classes.push('collapsed') }
      if (!this.userAuthenticated) { classes.push('pt-6') }
      return classes
    },
    mobileLanguageSelectionClasses () {
      const classes = []
      if (!this.hamburgerMenu.languageSelection.active) {
        classes.push('collapsed')
      }
      return classes
    },
    i18nSaveButtonProps () {
      return {
        variant: ButtonVariants.primary,
        size: ButtonSizes.small
      }
    },
    userAvatar () {
      let avatar = this.user.avatar ? `avatar-${this.user.avatar}` : 'avatar-donnie'
      avatar = avatar.toLowerCase()
      return convertSrcSet({
        desktop: {
          '1x': '/img/desktop/avatars/' + avatar + '.webp',
          '2x': '/img/desktop/avatars/' + avatar + '.webp'
        }
      })
    }
  },
  watch: {
    $route () {
      this.accountDropdown.active = false
      this.i18nDropdown.active = false
    }
  },
  methods: {
    toggleAccountDropdown (value = null) {
      this.i18nDropdown.active = false
      this.accountDropdown.active = typeof value === 'boolean' ? value : !this.accountDropdown.active
    },
    getEuros (amount) {
      return getEuros(this.country ? this.country.svg : 'nl', amount)
    },
    deactivateAccountDropdown () {
      this.accountDropdown.active = false
    },
    deactivateI18nDropdown () {
      this.i18nDropdown.active = false
    },
    toggleHamburgerMenu (value = null, link = null) {
      this.hamburgerMenu.display = value !== null ? value : !this.hamburgerMenu.display
      togglePageScroll(this.hamburgerMenu.display)

      if (link) {
        const currentRouteIsHomepage = this.$router.currentRoute.matched.find(route => route.path === '/:lang')
        if (link === 'index' && currentRouteIsHomepage) {
          window.location.reload()
          return false
        }

        this.$router.push(this.$i18n.localePath({ name: link }))
      }
    },
    setCountry (country) {
      this.country = {
        svg: country.svg,
        label: `Countries.${country.svg}`
      }
    },
    setLanguage (language) {
      this.language = {
        svg: language.svg,
        label: language.label,
        value: language.value
      }
    },
    onHamburgerClick () {
      this.hamburgerMenu.display = false
      togglePageScroll(this.hamburgerMenu.display)
    },
    onSubmitI18n (e) {
      e.preventDefault()
      this.setSignupState(defaultState)
      this.$i18n.switchLocalePath(this.language.value, this.country.svg)
      this.$moment.locale(this.language.svg)
      this.toggleHamburgerMenu(false)
      this.i18nDropdown.active = false
      this.hamburgerMenu.languageSelection.active = false
    },
    logout () {
      this.toggleHamburgerMenu(false)
      this.$emit('logout')
    },
    ...mapMutations('signup', {
      setSignupState: SET_SIGNUP_STATE
    }),
    onMenuClick (menuItem) {
      this.toggleHamburgerMenu(false)
      if (menuItem.hash) {
        this.$fireEvent(ROUTER_HASH_UPDATED.event, menuItem.hash)
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
  @media (max-width: 920px) {
    .xs-px-0 {
      @apply px-0 !important;
    }

    .xs-px-5 {
      @apply px-5 !important;
    }
  }

  .bottom-border {
    @aaply w-full !important;
    max-width: 125.4rem !important;
  }

  .svg-alert {
    @apply bg-red-300 rounded-full w-5 h-5 flex justify-center items-center text-white absolute;
    top: -0.7rem;
    left: 2rem;
  }

  .obutton.px-3 {
    @apply px-3 !important;
  }

  .avatar >>> img {
    @apply w-12 h-12 rounded-full;
  }

  .navbar-banner-spacer {
    margin-bottom: 13rem;
  }

  @screen md {
    .svg-alert {
      left: 3rem;
    }

    .avatar >>> img {
      @apply w-9 h-9 rounded-full;
    }

    .navbar-banner-spacer {
      @apply mb-0;
    }
  }

  .desktop-menu {
    a:hover:after,
    .nuxt-link-exact-active:after {
      @apply absolute border-b border-orange-300 bottom-0;
      content: '';
      left: 50%;
      width: 2.6rem;
      margin-left: -1.3rem;
    }
  }

  .select-country {
    >>> {
      .vs__search {
        @apply hidden;
      }

      .vs--open {
        .vs__search {
          @apply block;
        }
      }
    }
  }

  .account-avatar {
    width: 3.4rem;
    height: 3.4rem;
  }

  .mobile-hamburger-bg {
    animation-duration: 300ms;
    &.inactive {
       @apply opacity-0 pointer-events-none;
       animation-name: mobileHamburgerBgOut;

    }
    &.active {
       @apply opacity-100;
       animation-name: mobileHamburgerBgIn;
    }
  }

  .mobile-hamburger {
    flex-flow: column;
    left: 100%;
    right: -90%;
    backdrop-filter: blur(1.5rem);
    --bg-opacity: .85;

    &.active {
      @apply right-0;
      left: 21.6%;
    }

    nav {
      @apply overflow-x-auto flex-1;
    }

    .mobile-menu {
      @apply transition duration-300 ease-out;
      transition-property: max-height;
      max-height: 55rem;
      &.collapsed {
        max-height: 0;
      }
    }

    .mobile-language-selection {
       @apply flex;
       flex-flow: column;

      .mobile-language-selection-list {
        @apply overflow-y-scroll transition duration-300 ease-out pb-12 mt-3;
        transition-property: max-height;
        max-height: 60vh;
        height: 54vh;

        &.collapsed {
         @apply pb-0 mt-0;
          max-height: 0;
        }
      }
    }
  }

  .payment-dot {
    top: 15rem;
    left: 3.7rem;
  }

  @keyframes mobileHamburgerBgIn {
    0% {
      @apply opacity-0;
    }
    100% {
      @apply opacity-100;
    }
  }

  @keyframes mobileHamburgerBgOut {
    0% {
      @apply opacity-100;
    }
    100% {
      @apply opacity-0;
    }
  }

</style>
